import React from 'react';
import noop from 'lodash/noop';
import Cookie from 'js-cookie';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { InsuranceInNetworkBadge } from '@zocdoc-frontend-common/assets-icons';
import { withVisibilitySensor } from '@zocdoc-frontend-common/utils-react';
import { slate70 } from '@zocdoc-mezzanine/foundations-colors';
import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';

const InsuranceConfirmedInNetworkSection = ({
    shouldShowInsuranceAdvocacy,
    className = '',
}) =>
    shouldShowInsuranceAdvocacy && (
        <InsuranceConfirmedInNetworkWrapper
            data-test={
                'insurance-advocacy-insurance-confirmed-in-network-wrapper'
            }
            className={className}
        >
            <StyledInsuranceInNetworkBadge /> Confirmed in-network by the doctor
        </InsuranceConfirmedInNetworkWrapper>
    );

const InsuranceConfirmedInNetworkWrapper = styled.div`
    display: flex;
    flex-direction: row;
    font-family: ${FontFamily.SharpSansSemibold};
    color: ${slate70};
    font-size: 15px;
    line-height: 19px;
`;

const StyledInsuranceInNetworkBadge = styled(InsuranceInNetworkBadge)`
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 5px;
`;

const InsuranceConfirmedInNetworkWithVisibilitySensor = withVisibilitySensor(
    InsuranceConfirmedInNetworkSection
);

export const InsuranceConfirmedInNetwork = ({
    sendMetric = noop,
    shouldShowInsuranceAdvocacy,
    __forceShowInsuranceAdvocacy = false,
    ...props
}) => {
    const hasViewedInsuranceAdvocacyInPwa = Cookie.get('zd_ins_adv', {
        path: '/',
        domain: window.location.hostname.replace(/^www/, ''),
    });

    return (
        <InsuranceConfirmedInNetworkWithVisibilitySensor
            shouldShowInsuranceAdvocacy={
                (hasViewedInsuranceAdvocacyInPwa === 'true' &&
                    shouldShowInsuranceAdvocacy) ||
                __forceShowInsuranceAdvocacy
            }
            onFirstScrollToComponent={() =>
                onFirstScrollToComponent(sendMetric)
            }
            {...props}
        />
    );
};

const onFirstScrollToComponent = sendMetric => {
    sendMetric({
        element: 'InsuranceConfirmedInNetwork',
        initiator: EVENT_INITIATORS.USER,
        interactionType: INTERACTION_TYPES.VIEW,
        action: 'Viewed Confirmed In-Network Message',
    });
};
